import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.scss';
import App from './App.jsx';

Sentry.init({
  dsn: 'https://59db4a8fded77b22688e6fd849843456@o4510686665441280.ingest.de.sentry.io/4510686717083728',
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
